const valueLabels = {
  admin: "Administrador",
  superior: "Administrador superior",
  gerente: "Gerente de loja",
  master: "Administrador Master",
  loja: "Loja",
  parceiro: "Parceiro",
  sistema: "Sistema",
  ativo: "Ativo",
  ativa: "Ativa",
  inativo: "Inativo",
  inativa: "Inativa",
  pendente: "Pendente",
  aprovado: "Aprovado",
  pago: "Pago",
  cancelado: "Cancelado",
  devolucao: "Devolução",
  devolvida: "Devolvida",
  "parcialmente devolvida": "Parcialmente devolvida",
  basico: "Básico",
  profissional: "Profissional",
  enterprise: "Enterprise",
  manual: "Manual",
  api: "API/ERP",
  erp: "ERP",
  qr: "QR Code",
  ganho: "Ganho",
  gasto: "Gasto",
  estorno: "Estorno",
  bronze: "Bronze",
  prata: "Prata",
  ouro: "Ouro",
  pix: "PIX",
  PIX: "PIX",
  recarga: "Recarga Celular",
  brinde: "Brinde",
  produto: "Produto",
  cupom: "Cupom",
};

const auditActionLabels = {
  user_registered: "Conta solicitada",
  user_status_updated: "Status de conta alterado",
  user_store_access_updated: "Vínculos de lojas atualizados",
  user_admin_role_updated: "Perfil administrativo atualizado",
  sub_admin_created: "Gerente liberado",
  partner_store_access_updated: "Lojas do parceiro atualizadas",
  loja_created: "Loja criada",
  loja_updated: "Loja atualizada",
  loja_levels_updated: "Níveis da loja atualizados",
  loja_deleted: "Loja inativada",
  loja_disabled: "Loja inativada",
  parceiro_created: "Parceiro criado",
  parceiro_updated: "Parceiro atualizado",
  parceiro_deleted: "Parceiro inativado",
  parceiro_disabled: "Parceiro inativado",
  venda_created: "Venda registrada",
  venda_erp_created: "Venda ERP sincronizada",
  venda_qr_created: "Venda QR registrada",
  venda_erp_cancelled: "Venda ERP cancelada",
  venda_erp_returned: "Devolução ERP registrada",
  tipo_recompensa_created: "Tipo de recompensa criado",
  recompensa_created: "Recompensa criada",
  recompensa_updated: "Recompensa atualizada",
  recompensa_disabled: "Recompensa desativada",
  resgate_created: "Resgate solicitado",
  resgate_status_updated: "Status do resgate alterado",
  campanha_created: "Campanha criada",
  campanha_updated: "Campanha atualizada",
  campanha_disabled: "Campanha desativada",
  campanha_enabled: "Campanha reativada",
  publicacao_created: "Publicação criada",
  publicacao_updated: "Publicação atualizada",
  publicacao_archived: "Publicação arquivada",
};

const auditEntityLabels = {
  user: "Conta",
  loja: "Loja",
  parceiro: "Parceiro",
  venda: "Venda",
  tipo_recompensa: "Tipo de recompensa",
  recompensa: "Recompensa",
  resgate: "Resgate",
  campanha: "Campanha",
  publicacao: "Publicação",
};

const lowercaseConnectors = new Set(["da", "de", "do", "das", "dos", "e"]);

export const formatDisplayValue = (value, fallback = "Não informado") => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const text = String(value).trim();
  if (valueLabels[text]) {
    return valueLabels[text];
  }

  const normalized = text.toLowerCase();
  if (valueLabels[normalized]) {
    return valueLabels[normalized];
  }

  return text
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word, index) => {
      if (index > 0 && lowercaseConnectors.has(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const formatAuditAction = (value) => auditActionLabels[value] || formatDisplayValue(value);
export const formatAuditEntity = (value) => auditEntityLabels[value] || formatDisplayValue(value);
export const formatUserType = (value) => formatDisplayValue(value);
export const formatAccountRole = (user) => {
  if (user?.is_master || user?.tipo === "master") return "Administrador Master";
  if (user?.tipo === "admin" && user?.admin_role === "gerente") return "Gerente de loja";
  if (user?.tipo === "admin") return "Administrador superior";
  return formatUserType(user?.tipo);
};
export const formatStatus = (value) => formatDisplayValue(value);
export const formatPlan = (value) => formatDisplayValue(value);
export const formatRewardType = (value) => formatDisplayValue(value);
export const formatSaleOrigin = (value) => formatDisplayValue(value);
export const formatProfession = (value) => formatDisplayValue(value);
export const formatLevel = (value) => formatDisplayValue(value, "Bronze");

export const POINT_TRANSACTION_KIND = {
  EARNED: "ganho",
  SPENT: "gasto",
  SALE_REVERSAL: "estorno",
};

export const getPointTransactionKind = (transacao) => {
  const tipo = String(transacao?.tipo || "").trim().toLowerCase();
  const descricao = String(transacao?.descricao || "").trim().toLowerCase();

  if (
    tipo === POINT_TRANSACTION_KIND.SALE_REVERSAL ||
    descricao.includes("venda cancelada erp") ||
    descricao.includes("devolucao erp") ||
    descricao.includes("devolução erp")
  ) {
    return POINT_TRANSACTION_KIND.SALE_REVERSAL;
  }

  if (tipo === POINT_TRANSACTION_KIND.SPENT) {
    return POINT_TRANSACTION_KIND.SPENT;
  }

  return POINT_TRANSACTION_KIND.EARNED;
};

export const isSaleReversalTransaction = (transacao = {}) => (
  Boolean(transacao?.venda_id) &&
  getPointTransactionKind(transacao) === POINT_TRANSACTION_KIND.SALE_REVERSAL
);

export const getPointTransactionDirection = (transacao) => {
  const kind = getPointTransactionKind(transacao);
  return kind === POINT_TRANSACTION_KIND.EARNED ? 1 : -1;
};

export const formatPoints = (value, fallback = "0") => {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) {
    return fallback;
  }

  return numberValue.toLocaleString("pt-BR", {
    minimumFractionDigits: Number.isInteger(numberValue) ? 0 : 2,
    maximumFractionDigits: 2,
  });
};

export const formatCurrency = (value, fallback = "R$ 0,00") => {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) {
    return fallback;
  }

  return numberValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};
